import * as React from 'react';
import { BaseForm } from './Base';
import { Button, ButtonStyle } from '../Button';
import { ProfileManager, ProfileContext } from '../../profile';
import { useRequestAsync, getHeaders } from '../../api/client';
import Loader from '../Loader';
import { ErrorFlash } from '../Flash';
import theme from '../../utils/theme';

type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

export interface Props extends InputProps {
  id: string;
  label: string;
  tooltip?: string;
  field: any;
  onValueChange: Function;
  defaultValue: any;
}

export interface ImageState {
  fileURL?: string;
  error?: Error;
}

const uploadFile = (context: ProfileManager) => {
  return useRequestAsync(
    (body: File) => ({
      body,
      url: `/upload/${body.name}`,
      method: 'POST',
      headers: {
        'Content-Type': body.type,
        ...getHeaders(context),
      },
    }),
    false,
  );
};

export default (props: Props) => {
  const context = React.useContext(ProfileContext);
  const [file, setFile] = React.useState<File>(null);
  const [state, submit] = uploadFile(context);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files.length > 0) {
      setFile(event.target.files[0]);
    }
  };

  const handleUpload = () => {
    if (file) {
      submit(file);
    }
  };

  React.useEffect(() => {
    if (state.complete && state.data) {
      props.onValueChange(props.field, state.data.file_url);
    }
  }, [state]);

  if (state.loading) {
    return (
      <BaseForm label={props.label} id={props.id} tooltip={props.tooltip}>
        <Loader />
      </BaseForm>
    );
  }

  return (
    <BaseForm label={props.label} id={props.id} tooltip={props.tooltip}>
      <div
        className={`${theme.form.field.input} border-box w-100 flex items-center`}
      >
        <input
          className={'border-box bw0 b--transparent w-100 mr2'}
          id={props.id}
          type="file"
          onChange={handleFileChange}
          accept=".jpg, .jpeg, .png"
        />
        {file && (
          <Button className={ButtonStyle.Normal} onClick={handleUpload}>
            UPLOAD
          </Button>
        )}
      </div>
      {state.error && <ErrorFlash error={state.error} />}
      {state.data && (
        <a className="link gold" href={state.data.file_url} target="_blank">
          VIEW
        </a>
      )}
    </BaseForm>
  );
};
